/**
 * A very simple translation service.
 */

import translations from "./translations.json";

type TranslationParams = { [key: string]: string | number };

const langTable = translations as { [lang: string]: { [key: string]: string } };

// Simple hook
export const useTranslation = (language: string) => {
  return (text: string, params?: TranslationParams): string => {
    let translated = langTable[language][text];
    translated = translated !== undefined ? translated : text;
    return interpolate(translated, params);
  };
}

function interpolate(template: string, params?: TranslationParams): string {
  if (!params) return template;
  return template.replace(/{{\s*(\w+)\s*}}/g, (_, key) =>
    params[key] !== undefined ? String(params[key]) : `{{${key}}}`
  );
}
